import axios from 'axios';

// Každá odpověď serveru nese aktuální usrInfo (role se v checkSec čtou z DB při
// každém requestu). App.js na tuto událost poslouchá a při změně role (např. zrušení
// členství) přenačte ikonky a stránky bez nutnosti zavírat appku.
export const USRINFO_EVENT = 'progressgym:usrinfo';

export default function post(act, data, options = {}) {
	return new Promise((resolve, reject) => {
		let url = `/rest?act=${act}`;

		axios({
			method: 'POST',
			withCredentials: true,
			data: data,
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
			},
			url: url,
		})
			.then((response) => {
				if (!options.skipAuthRedirect && !response.data.usrInfo.token && response.data.usrInfo.usrId > -1) {
					if (act !== 'login' && act !== 'forget' && act !== 'restoreValidCode' && act !== 'restore' && act !== 'register' && act !== 'activate' && act !== 'verifyPromoCode') {
						localStorage.removeItem('token');
						window.location.pathname = '/';
					}
				}

				if (response.data.usrInfo && response.data.usrInfo.usrId > 0) {
					window.dispatchEvent(new CustomEvent(USRINFO_EVENT, {detail: response.data.usrInfo}));
				}

				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
			});
	});
}
